module.exports = __webpack_public_path__ + "img/75.6c42c182.png";